import React, { Component } from 'react';
import PropTypes from 'prop-types';

class AttributeList extends Component {
  renderColumn (params) {
    return (
      <table style={{ width: '48%' }}>
        <tbody>
          {
            params.map((item, idx) => (
              <tr key={idx}>
                <td className='label'>{item.getLabel()}</td>
                <td className={'value' + (item.isActive() ? '' : ' muted')}>
                  {item.getValue()}
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    );
  }

  render () {
    const { attributeList, className } = this.props;
    const length = attributeList.length;
    const col1 = attributeList.slice(0, (length - 1) / 2 + 1);
    const col2 = attributeList.slice((length - 1) / 2 + 1);

    return (
      <div className={'attribute-list flex flex-between ' + className}>
        { this.renderColumn(col1)}
        { this.renderColumn(col2)}
      </div>
    );
  }
}

AttributeList.propTypes = {
  attributeList: PropTypes.array,
  className: PropTypes.string
};

AttributeList.defaultProps = {
  attributeList: [],
  className: ''
};

export default AttributeList;



// WEBPACK FOOTER //
// ./src/ui/Views/AttributeList.jsx